import { TPannellumConfig } from '../../types/panellum';

const basePath = 'https://static.treedis.com/projects/shbiro-neve-zemer';

export const pannellumConfigShbiroNeveZemer: { [key: number]: TPannellumConfig } = {
  1: {
    type: 'multires',
    pitch: -15,
    hfov: 100.0,
    yaw: 5,
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hotSpots: [
      {
        pitch: -12.5,
        yaw: 5.628451421507544,
        type: 'info',
        createTooltipArgs: {
          title: 'שבירו נווה זמר',
          type: 'building',
          stem: 50,
        },
      },
      {
        pitch: -37.054117683864156,
        yaw: -122.96457898939491,
        type: 'info',
        createTooltipArgs: {
          title: 'אשכול גן ילדים ',
          type: 'building',
          stem: 50,
        },
      },
      {
        pitch: -2.119175826191766,
        yaw: -101.71276024339522,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 4',
          type: 'building',
          stem: 50,
        },
      },
      {
        pitch: -4.985445974333214,
        yaw: -97.19002044349395,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון רננים ',
          stem: 50,
          type: 'poi',
          cardDescription: 'קניון רננים',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 5, walk: 18, bicycle: 5 },
        },
      },
      {
        pitch: -4.550384693498163,
        yaw: 29.408132196841848,
        type: 'info',
        createTooltipArgs: {
          title: 'מרכז מסחרי נווה זמר ',
          stem: 50,
          type: 'poi',
          cardDescription: 'מרכז מסחרי נווה זמר',
          cardImageSrc: `${basePath}/pano/tags/image3.webp`,
          transportation: { car: 2, walk: 9, bicycle: 3 },
        },
      },
      {
        pitch: -4.649531610507498,
        yaw: -82.69149815514538,
        type: 'info',
        createTooltipArgs: {
          title: 'קאנטרי רעננה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קאנטרי רעננה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 4, walk: 18, bicycle: 4 },
        },
      },
      {
        pitch: -0.3377796320642936,
        yaw: 44.66813321728637,
        type: 'info',
        createTooltipArgs: {
          title: 'פארק רעננה',
          stem: 50,
          type: 'poi',
          cardDescription: 'פארק רעננה',
          cardImageSrc: `${basePath}/pano/tags/image4.webp`,
          transportation: { car: 8, walk: 41, bicycle: 11 },
        },
      },
      {
        pitch: 1.3943393600277842,
        yaw: 3.4914975886233606,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene2.webp`,
        },
      },
    ],
  },
  2: {
    type: 'multires',
    hfov: 90.0,
    pitch: -8,
    yaw: 10,
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hotSpots: [
      {
        pitch: -8.545014241925244,
        yaw: 10.301650069796572,
        type: 'info',
        createTooltipArgs: {
          title: 'שבירו נווה זמר',
          type: 'building',
          stem: 50,
        },
      },
      {
        pitch: -0.8882311992189893,
        yaw: -60.212148688516095,
        type: 'info',
        createTooltipArgs: {
          title: 'כביש 4',
          type: 'building',
          stem: 50,
        },
      },
      {
        pitch: -2.5862734696016445,
        yaw: -47.530759413989415,
        type: 'info',
        createTooltipArgs: {
          title: 'קניון רננים ',
          stem: 50,
          type: 'poi',
          cardDescription: 'קניון רננים',
          cardImageSrc: `${basePath}/pano/tags/image2.webp`,
          transportation: { car: 5, walk: 18, bicycle: 5 },
        },
      },
      {
        pitch: -2.3610336864114556,
        yaw: -36.4730174150842,
        type: 'info',
        createTooltipArgs: {
          title: 'קאנטרי רעננה',
          stem: 50,
          type: 'poi',
          cardDescription: 'קאנטרי רעננה',
          cardImageSrc: `${basePath}/pano/tags/image1.webp`,
          transportation: { car: 4, walk: 18, bicycle: 4 },
        },
      },
      {
        pitch: -0.8781348609833232,
        yaw: 97.44794793348564,
        type: 'info',
        createTooltipArgs: {
          title: 'פארק רעננה',
          stem: 50,
          type: 'poi',
          cardDescription: 'פארק רעננה',
          cardImageSrc: `${basePath}/pano/tags/image4.webp`,
          transportation: { car: 8, walk: 41, bicycle: 11 },
        },
      },
      {
        pitch: -16.43487749246012,
        yaw: -58.428580696850304,
        type: 'info',
        createTooltipArgs: {
          title: 'אשכול גן ילדים ',
          type: 'building',
          stem: 50,
        },
      },
      {
        pitch: 4.666645615899732,
        yaw: 10.471264985385233,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene1.webp`,
        },
      },
    ],
  },
};
